'use client'

import { Button } from '@chakra-ui/react'
import { ShieldCheck } from 'lucide-react'
import { useTranslation } from 'react-i18next'
import { useSsoLogin } from '../model/use-sso-login'

export function AuthMethodSelector() {
  const { t } = useTranslation()
  const { startSsoLogin } = useSsoLogin()

  return (
    <Button
      w="full"
      size="lg"
      bg="primary.solid"
      color="white"
      borderRadius="lg"
      fontWeight="600"
      fontSize="sm"
      h="48px"
      borderWidth="1px"
      borderColor="primary.solid"
      _hover={{
        bg: 'white',
        color: 'primary.solid',
        borderColor: 'primary.solid',
      }}
      _active={{ bg: '#7a2120' }}
      onClick={startSsoLogin}
    >
      <ShieldCheck size={16} />
      {t('auth.method.sso')}
    </Button>
  )
}
